import { WebSummaryModel } from '../../microsoft/sharepoint/web-summary-model';

export class SiteSummaryModel {
  id: string;
  portalName: string;
  rootWeb: WebSummaryModel;
}
